import mixpanelTrack from '~/app/shared/util/utilities/mixpanel';
import { ApplaiData } from './ai-chat/types';

type InAppHelpMixpanelAction = 'ai-chat' | 'ai-chat.events' | 'drawer.toggle' | 'mail' | 'navigation' | 'phone';

function track(action: InAppHelpMixpanelAction, data: object) {
    mixpanelTrack('inapphelp', action, data);
}

interface InAppHelpMixpanelNavigationData {
    item: string;
    placement: 'help-drawer' | 'sidebar' | 'top-nav';
}

export function trackNavigation(data: InAppHelpMixpanelNavigationData) {
    track('navigation', data);
}

export function trackAiChat(data: { action: string }) {
    track('ai-chat', data);
}

export function trackAiChatEvents(data: { event: ApplaiData['type']; data: object }) {
    track('ai-chat.events', data);
}

export function trackDrawerToggle(data: { action: 'open' | 'close' }) {
    track('drawer.toggle', data);
}

export function trackMail(data: { action: 'from-computer' | 'send-mail' | 'take-screenshot' }) {
    track('mail', data);
}

export function trackPhone(data: { action: 'copy-phone-number' | 'request-a-call' }) {
    track('phone', data);
}
